"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MountedRoots {
    constructor() {
        this.roots = new Map(); // Store mounted roots by element
    }
    add(element, { root, componentName, props }) {
        this.roots.set(element, { root, componentName, props });
    }
    get(element) {
        return this.roots.get(element);
    }
    updateProps(element, newProps) {
        const mounted = this.get(element);
        if (mounted) {
            mounted.props = newProps;
        }
    }
    has(element) {
        return this.roots.has(element);
    }
    warnIfNotMounted(element) {
        if (!this.has(element)) {
            console.warn("No mounted component found for the specified element.");
        }
    }
}
exports.default = MountedRoots;
